import {
    ADMIN_CUSTOMERS_ROUTES,
    ADMIN_ORDERS_ROUTES,
    ADMIN_PRODUCTION_LINE_ROUTES,
    ADMIN_PRODUCTS_ROUTES,
    ADMIN_TEMPLATES_ROUTES,
    CUSTOMERS_ROUTES,
    ORDERS_ROUTES,
    PRODUCTS_ROUTES
} from '@/router/routes'
import { ADMIN_CUSTOMERS_LIST_ROUTE_NAME } from '@/router/routing/admin/adminCustomersRoutes'
import { ADMIN_ORDERS_LIST_ROUTE_NAME } from '@/router/routing/admin/adminOrdersRoutes'
import { ADMIN_PRODUCTS_LIST_ROUTE_NAME } from '@/router/routing/admin/adminProductsRoutes'
import { ADMIN_TEMPLATES_LIST_ROUTE_NAME } from '@/router/routing/admin/adminTemplatesRoutes'
import {
    CUSTOMERS_DETAIL_ROUTE_NAME,
    CUSTOMERS_LIST_ROUTE_NAME
} from '@/router/routing/customersRoutes'
import { ORDERS_DETAIL_ROUTE_NAME, ORDERS_LIST_ROUTE_NAME } from '@/router/routing/ordersRoutes'
import {
    PRODUCTS_DETAIL_ROUTE_NAME,
    PRODUCTS_LIST_ROUTE_NAME
} from '@/router/routing/productsRoutes'
import { TEMPLATES_ROUTE, TEMPLATES_ROUTE_NAME } from '@/router/routing/templateRoutes'
import type { MenuItemType } from '@rfc/rfc-components-library/types'
import { ADMIN_PRODUCTION_LINE_LIST_ROUTE_NAME } from './routing/admin/adminProductionLinesRoutes'

export const menuRoutesTop: MenuItemType[] = [
    {
        label: 'menu.orders',
        icon: 'mdi-clipboard-list-outline',
        to: ORDERS_ROUTES.baseUrl,
        names: [ORDERS_LIST_ROUTE_NAME, ORDERS_DETAIL_ROUTE_NAME],
        permissions: true
    },
    {
        label: 'menu.customers',
        icon: 'mdi-account-group',
        to: CUSTOMERS_ROUTES.baseUrl,
        names: [CUSTOMERS_LIST_ROUTE_NAME, CUSTOMERS_DETAIL_ROUTE_NAME],
        permissions: true
    },
    {
        label: 'menu.products',
        icon: 'mdi-tag-multiple',
        to: PRODUCTS_ROUTES.baseUrl,
        names: [PRODUCTS_LIST_ROUTE_NAME, PRODUCTS_DETAIL_ROUTE_NAME],
        permissions: true
    },
    {
        label: 'menu.templates',
        icon: 'mdi-file-document-outline',
        to: TEMPLATES_ROUTE,
        names: [TEMPLATES_ROUTE_NAME],
        permissions: true
    }
]

export const menuAdminView: MenuItemType[] = [
    {
        icon: 'mdi-clipboard-list-outline',
        label: 'menu.adminOrders',
        names: [ADMIN_ORDERS_LIST_ROUTE_NAME],
        to: ADMIN_ORDERS_ROUTES.baseUrl,
        permissions: true
    },
    {
        icon: 'mdi-account-group',
        label: 'menu.adminCustomers',
        names: [ADMIN_CUSTOMERS_LIST_ROUTE_NAME],
        to: ADMIN_CUSTOMERS_ROUTES.baseUrl,
        permissions: true
    },
    {
        icon: 'mdi-tag-multiple',
        label: 'menu.adminProducts',
        names: [ADMIN_PRODUCTS_LIST_ROUTE_NAME],
        to: ADMIN_PRODUCTS_ROUTES.baseUrl,
        permissions: true
    },
    {
        icon: 'mdi-file-document-outline',
        label: 'menu.adminTemplates',
        names: [ADMIN_TEMPLATES_LIST_ROUTE_NAME],
        to: ADMIN_TEMPLATES_ROUTES.baseUrl,
        permissions: true
    },
    {
        icon: 'mdi-file-document-outline',
        label: 'menu.adminProductionLines',
        names: [ADMIN_PRODUCTION_LINE_LIST_ROUTE_NAME],
        to: ADMIN_PRODUCTION_LINE_ROUTES.baseUrl,
        permissions: true
    }
]
